import React from "react";
import MainImage from "../../../assets/Braiders/JaJas-African-Hair-Braiding-Arena-Stg_195-scaled.jpg";
import Footer from "../../../components/Footer";
import NavLite from "../../../components/NavLite";
import StarterBraider from "../../../components/Braiders/StarterBraider";
import GrowthBraider from "../../../components/Braiders/GrowthBraider";
import VIPBraider from "../../../components/Braiders/VIPBraider";
import Brandlist from "../../../components/Brandlist";
import PastWordBraids from "../../../components/Braiders/PastWordBraids";
import TestimonialsSection from "../../../components/Braiders/TestimonialsSection";
import BraiderFunnel from "../../../components/Braiders/BraiderFunnel";

function HoustonBraiderPage() {
  return (
    <main className="relative min-h-screen w-screen overflow-x-hidden bg-[#F6F3F1]">
      <title>
        Hair Braider Website Design in Houston, TX | Woaom Web Design
      </title>
      <meta
        name="description"
        content="Custom websites for hair braiders in Houston, TX with booking, SEO, and marketing systems. Look professional, attract more clients, and grow your braiding business in Houston."
      />
      <meta
        name="keywords"
        content="Hair Braiding Website Design in Houston, TX, Best Hair Braiding Website Templates Houston, Custom Hair Braider Websites Houston, Professional Hair-Braiding Portfolio Website Houston, Hair Braiding Website with Booking in Houston, Affordable Hair Braiding Site Design for Houston Stylists, SEO for Hair Braiders – Houston Website Services, Mobile-Friendly Hair-Braiding Websites in Houston, Local Hair Braiding Business Website Houston, Top Hair Braiding Website Examples in Houston, Hair Braiding Salon Website Houston, Hair Braids Portfolio Website – Houston, Box Braids Website Design in Houston, Knotless Braids Site Design Houston, African Hair Braiding Website Houston, Hair Braid Booking Website Design Houston, Hair Braiding Service Website Optimization – Houston, Responsive Hair Braiding Website Houston, Hair Braiding Website Builder for Houston Braiders, Get Hair Braiding Clients via Website in Houston"
      />

      {/* Hero Section */}
      <section className="bg-[#F6F3F1]">
        <div
          className="relative h-auto bg-cover bg-center object-top"
          style={{
            clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
            backgroundImage: `url(${MainImage})`,
            padding: "20px",
            width: "100%",
          }}
        >
          {/* Overlay */}
          <NavLite />

          {/* Hero copy overlay */}
          <div className="mx-auto w-full max-w-7xl px-5 md:px-10 md:py-40 py-56">
            <div className="max-w-3xl bg-white/80 backdrop-blur-sm rounded-2xl p-6 md:p-8 shadow-lg">
              <p className="uppercase text-xs tracking-widest text-black mb-2">
                for Houston braiders
              </p>
              <h1 className="text-4xl md:text-5xl font-semibold text-gray-900 leading-tight">
                Houston braiders — let your website keep clients booking.
              </h1>
              <p className="mt-3 text-gray-700 md:text-lg">
                We design websites that make it easy for Houston clients to
                discover you, book instantly, and come back again.
              </p>
              <div className="mt-6 flex flex-wrap gap-3">
                <a href="#packages">
                  <button className="bg-[#C18343] text-white uppercase tracking-widest px-6 py-3 text-sm hover:bg-[#a76e33] transition-colors rounded-lg">
                    View Packages →
                  </button>
                </a>
                <a
                  href="https://cal.com/woaomwebdesign/15min "
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="bg-white text-gray-900 border border-gray-300 rounded-lg px-6 py-3 text-sm hover:bg-gray-50 transition-colors">
                    Free 15-min Consult
                  </button>
                </a>
              </div>
              <p className="mt-4 text-sm text-gray-600">
                Trusted by braiders in Houston, Dallas, and across Texas.
              </p>
            </div>
          </div>
        </div>

        {/* Intro */}
        <div className="mx-auto max-w-7xl px-5 py-10 md:px-10 text-center">
          <p className="uppercase text-sm text-[#c6884a] tracking-widest mb-2">
            Best Websites for Houston Braiders
          </p>
          <h2 className="mb-4 text-3xl md:text-5xl text-black">
            Websites That Help Houston Braiders Grow
          </h2>
          <p className="mx-auto mb-5 max-w-3xl text-sm text-gray-600 sm:text-xl">
            At Woaom Web Design, we build professional websites with booking,
            SEO, and marketing systems to help Houston braiders book more
            clients and grow their businesses.
          </p>
        </div>

        {/* Packages */}
        <div id="packages" className="scroll-mt-24">
          <StarterBraider />
          <GrowthBraider />
          <VIPBraider />
        </div>

        {/* Why Choose Section */}
        <div className="mx-auto max-w-5xl px-5 py-10 text-center">
          <h3 className="text-3xl md:text-4xl text-gray-900 mb-6">
            Why Houston Braiders Choose Woaom Web Design
          </h3>
          <ul className="text-gray-700 space-y-3 text-lg">
            <li>✨ Niche expertise in beauty & women-owned businesses</li>
            <li>✨ Websites that attract clients & increase bookings</li>
            <li>✨ Booking, payments, reviews, and SEO included</li>
            <li>✨ From side-hustle to salon, we help you grow</li>
          </ul>
        </div>

        {/* Credibility: As Seen On / Brand list */}
        <Brandlist />

        {/* Call To Action */}
        <div className="text-center py-12">
          <h3 className="text-3xl md:text-4xl mb-4 text-gray-900">
            Ready to Build Your Braiding Website in Houston?
          </h3>
          <p className="text-gray-700 mb-6">
            Let’s create the website and marketing system that helps your Houston
            braiding business stand out and grow.
          </p>
          <a href="/contact">
            <button className="bg-[#C18343] text-white uppercase tracking-widest px-8 py-4 text-sm hover:bg-[#a76e33] transition-colors rounded-lg">
              Book Your Package Today →
            </button>
          </a>
          <p className="text-xs text-gray-600 mt-3">
            Limited spots available monthly • 100% satisfaction guarantee
          </p>
        </div>

        <PastWordBraids />
        <TestimonialsSection />
        <BraiderFunnel />
        <Footer />
      </section>
    </main>
  );
}

export default HoustonBraiderPage;
